import { render, staticRenderFns } from "./BitcoinPaymentPage.vue?vue&type=template&id=7843f067&"
import script from "./BitcoinPaymentPage.vue?vue&type=script&lang=js&"
export * from "./BitcoinPaymentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7843f067')) {
      api.createRecord('7843f067', component.options)
    } else {
      api.reload('7843f067', component.options)
    }
    module.hot.accept("./BitcoinPaymentPage.vue?vue&type=template&id=7843f067&", function () {
      api.rerender('7843f067', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BitcoinPaymentPage.vue"
export default component.exports